import { render } from "./modal-all-commodity.vue?vue&type=template&id=35c3b9ac&scoped=true&ts=true"
import script from "./modal-all-commodity.vue?vue&type=script&lang=ts"
export * from "./modal-all-commodity.vue?vue&type=script&lang=ts"

import "./modal-all-commodity.vue?vue&type=style&index=0&id=35c3b9ac&scoped=true&lang=css"

import exportComponent from "/app/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-35c3b9ac"]])

export default __exports__